import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'

export const colunaTipoAvaliacao = (): TabelaColuna => ({
  Chave: 'tipoAvaliacao',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => <span>{linha.tipoAvaliacao}</span>,
  RenderizarCabecalho: () => <div style={{ width: 100 }}>Tipo Avaliação</div>
})
